namespace GeniuzPOS.Administration {
    export class PsFuncKbMapShiftCodeColumns {
        static columnsKey = 'Administration.PsFuncKbMapShiftCode';
    }
}
